import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import VehiclesCertificationSale from './tccSale';
import ListVehiclesCertification from './listTcc';
import VehicleCertification from './tcc';

export const vehicleCertificationRoutes = [
  {'component': <VehicleCertification />, 'path': paths.SearchVehicleCertification},
  {'component': <VehicleCertification />, 'path': paths.VehiclesCertification},
  {'component': <ListVehiclesCertification />, 'path': paths.ListVehiclesCertification},
  {'component': <VehiclesCertificationSale />, 'path': paths.VehiclesCertificationSale},
];
